import { api } from './api';

export const fetchAlarms = (params, options) => {
  const payload = new URLSearchParams();
  Object.entries(params).map(([key, value]) => {
    if (Array.isArray(value)) return value.map((item) => payload.append(key, item));
    else return payload.append(key, value);
  });
  return api.get('/conditional/instances', payload, options);
};

export const fetchAlarmsTypes = (params) => {
  return api.get('/conditional/configurations', params);
};

export const fetchAddComment = (payload) => {
  return api.post('/comment', payload);
};

export const fetchUpdateAlarm = (id, payload) => {
  return api.put(`/conditional/instance/${id}`, payload);
};

export const fetchAlarmById = (id) => {
  return api.get(`/conditional/instance/${id}`);
};

export const bulkChangeAlarmsStatus = (payload) => {
  return api.put(`/conditional/instance/bulk`, payload);
};
